module.exports = __webpack_public_path__ + "static/media/aboutUs.02e139f2.svg";